import { useCallback, useEffect, useState } from "react";

const ACTIVE_TIMEOUT = 20000; // 20 seconds

const useUserIsActive = () => {
  const [lastActive, setLastActive] = useState<Date | null>(null);

  const onVisibilitychange = useCallback(() => {
    if (document.visibilityState === "visible") {
      setLastActive(new Date());
    } else {
      setLastActive(null);
    }
  }, []);

  const onMouseMove = useCallback(() => {
    setLastActive(new Date());
  }, []);

  const onFocus = useCallback(() => {
    setLastActive(new Date());
  }, []);

  const onBlur = useCallback(() => {
    setLastActive(null);
  }, []);

  useEffect(() => {
    window.addEventListener("visibilitychange", onVisibilitychange);
    // window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);

    return () => {
      window.removeEventListener("visibilitychange", onVisibilitychange);
      // window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, [onBlur, onFocus, onMouseMove, onVisibilitychange]);

  useEffect(() => {
    const timeout = setTimeout(() => setLastActive(null), ACTIVE_TIMEOUT);
    return () => clearTimeout(timeout);
  }, [lastActive]);

  return lastActive !== null;
};

export default useUserIsActive;
